module.exports = __webpack_public_path__ + "static/media/lebenshilfe_avatar_4a.4e66cee2.svg";